import React from 'react';
import { Link } from "react-router-dom";

export const TrendingNow = () => {
    return (
        <div className="border_style">
            <h2 className="flex mb-8 text-3xl">TRENDING NOW</h2>
            <div className="grid md:grid-cols-4 grid-cols-2 lg:grid-cols-4 gap-7">
                <div><Link to="#"><img src="images/offer-1.jpg" alt="Offer" /></Link></div>
                <div><Link to="#"><img src="images/offer-2.jpg" alt="Offer" /></Link></div>
                <div><Link to="#"><img src="images/offer-3.jpg" alt="Offer" /></Link></div>
                <div><Link to="#"><img src="images/offer-4.jpg" alt="Offer" /></Link></div>
            </div>
        </div>
    )
}
